import { UserPermissionData } from './user'

/** init시 앱 강제 업데이트 상태 */
export enum AppUpdateStatus {
  FORCED = 'forced', // 강제 업데이트
  OPTIONAL = 'optional', // 선택 업데이트 (나중에 가능)
  LATEST = 'latest', // 최신
}

/** 안드로이드는 impact를 사용하면 너무 진동이 크기에 duration으로 대체. */
export enum AndroidImpactDuration {
  Minimum = 1,
  Light = 2,
  Medium = 3,
  Heavy = 4,
}

// prettier-ignore
export enum UrlRegex {
  FAVOUR_TOURNAMENT_RESULT = 'fw\/result\/\\d+',
  FAVOUR_TOURNAMENT_SUMMARY = 'fw\/summary\/\\d+',
  FAVOUR_TOURNAMENT_ANSWER = 'fw\/detail\/\\d+\/(host|guest)',
  MBTI_RESULT = 'quiz\/report\/\\d+',
  MBTI_ANSWER = 'answer\/\\d+\/(host|guest)'
}

export type SocialShareType = 'kakao' | 'qr' | 'x' | 'link' | 'whatsApp'

export interface GenericResponse {
  data: any
}

export interface GenericPaginatedListResponse extends GenericResponse {
  cursor?: string
}

export type ExperimentData = {
  key: number
  groups: ExperimentGroup[]
}

export type ExperimentGroup = {
  number: number
  weight: number
}

/** 앱 실행시 가져오는 데이터로서, user permission 데이터들을 포함 */
export interface InitData extends UserPermissionData {
  isLoggedIn: boolean
  updateStatus: AppUpdateStatus
  experiments: ExperimentData[]
  isKakaoUser?: boolean
  jwtToken?: string
}

export interface InitResponse extends GenericResponse {
  data: InitData
}

export interface NoticeListResponse extends GenericResponse {
  data: Notice[]
}

export interface Notice {
  id: number
  title: string
  content: string
  image: string
  link: string
}

export interface TokenResponse extends GenericResponse {
  data: {
    isNewUser: boolean
    jwtToken: string
  }
}

export type FeedCard = {
  image: string
  moveTo: string
  ordering: number
  subtitle: string
  title: string
}

export type FeedCardListResponse = GenericResponse & {
  data: FeedCard[]
}

export type HomeCarouselCardData = {
  image: string
  moveTo: string
  ordering: number
  subtitle: string
  title: string
  type: HomeCarouselDataType
}

export type HomeCarouselListResponse = GenericResponse & {
  data: HomeCarouselCardData[]
}

export enum HomeCarouselDataType {
  CAROUSEL_GROUP_1 = 'CAROUSEL_GROUP_1',
  CAROUSEL_GROUP_2 = 'CAROUSEL_GROUP_2',
  BANNER = 'BANNER',
}

export interface ShareOptions {
  /**
   * Set a title for any message. This will be the subject
   * if sharing to email
   *
   * @since 1.0.0
   */
  title?: string
  /**
   * Set some text to share
   *
   * @since 1.0.0
   */
  text?: string
  /**
   * Set a URL to share, can be http, https or file:// URL
   *
   * @since 1.0.0
   */
  url?: string
  /**
   * Set a title for the share modal.
   * This option is only supported on Android.
   *
   * @since 1.0.0
   */
  dialogTitle?: string
}
